import { MarkDashboardExportDownloadedMutation } from "@/graphql/generated/graphql";
import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { useMutation } from "@tanstack/react-query";

import { markDashboardExportDownloadedMutationDocument } from "./dashboard-export.gql";

interface MarkDashboardExportDownloadedInput {
  workspaceId: string;
  id: string;
}

export function useMarkDashboardExportDownloaded() {
  return useMutation({
    mutationFn: async (
      input: MarkDashboardExportDownloadedInput,
    ): Promise<MarkDashboardExportDownloadedMutation["markDashboardExportDownloaded"]> => {
      const client = createOperationClient("markDashboardExportDownloaded");
      const data = await client.request(markDashboardExportDownloadedMutationDocument, input);
      return data.markDashboardExportDownloaded;
    },
  });
}
